import httpClient from './httpClient'

export default {
  async getProfile() {
    let ret = await httpClient.get('profile')
    return ret
  },
  async getProfileId(profile_id) {
    let ret = await httpClient.get(`profile/${profile_id}`)
    return ret
  },
  async createProfile(name) {
    let ret = await httpClient.post('profile', {
      name: name,
      exclusive: true,
    })
    return ret
  },
  async updateProfile(profile_id, config) {
    let ret = await httpClient.put(`profile/${profile_id}`, config)
    return ret
  },
  async setProfileToVideos(profile, videos) {
    let ret = await httpClient.post('profile/?type=set-videos', {
      profile: profile,
      videos: videos,
    })
    return ret
  },
}
